import { isOfflineExemptRoute } from '~/utils/offline-routes.js'

export default ({ store, app: { router, context } }, inject) => {


	if (process.browser) {

		  	// initialise the last store state from browser
		    store.commit('basket/INITIALISE_STORE');
		    store.commit('persisted/INITIALISE_STORE');

			// Subscript to all store changes and store them locally in the browser for nativeness
			store.subscribe((mutation, state) => {
			    // Store the state object as a JSON string
			    try{
			        localStorage.setItem('toggle_basket', JSON.stringify(state.basket));
			        localStorage.setItem('toggle_persisted', JSON.stringify(state.persisted));
			    }catch(e){  // local storage disabled, so we won't use it.
			    }
			});


			if(!store.getters.getAccount.id){
	          store.commit("RESET_STORE");
	          router.push({name:'notfound'});
	          return;
	        }

	        if(!store.getters.getAccount.storeLive && !isOfflineExemptRoute(context.route.name))
		        store.dispatch('storeOffline', router);

		    // if the user visited the default domain and there is a custom domain setup, redirect there.
	        if(store.getters.getAccount.domain != window.location.hostname && window.location.hostname == store.getters.getAccount.default_domain)
	            window.location.href = 'https://'+store.getters.getAccount.domain+window.location.pathname;
	        

	}
}